import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Route } from 'react-router-dom';
import { withRum } from './RumRouteComponentWrapper';
export var RumRoute = function (_a) {
    var children = _a.children, component = _a.component, render = _a.render, otherProps = __rest(_a, ["children", "component", "render"]);
    var RumComponent = useMemo(function () {
        var _a;
        // this is react-router priority
        return withRum((_a = children !== null && children !== void 0 ? children : component) !== null && _a !== void 0 ? _a : render);
    }, [children, component, render]);
    return _jsx(Route, __assign({}, otherProps, { component: RumComponent }), void 0);
};
//# sourceMappingURL=RumRoute.js.map